import { PublicClientApplication, Configuration } from '@azure/msal-browser';

// All three values are env-driven so the same bundle can be pointed at
// any tenant URL without rebuilding source. Defaults match the dev Entra
// app registration so localhost dev keeps working without an .env tweak.
// In production set REACT_APP_MSAL_REDIRECT_URI to the tenant's origin
// (e.g. https://acme.app.goeswestservices.com) and re-register the URI
// in the Entra app.
const clientId    = process.env.REACT_APP_MSAL_CLIENT_ID    ?? '39a5c3e3-181c-45fe-91d8-ee90986a9cb7';
const tenantId    = process.env.REACT_APP_MSAL_TENANT_ID    ?? 'aae5576c-c4cd-43c6-8869-7521fb55a45c';
const redirectUri = process.env.REACT_APP_MSAL_REDIRECT_URI ?? 'http://localhost:3000';

const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};
